import { render, staticRenderFns } from "./GCheckButtonIcon.vue?vue&type=template&id=5acba5cf&scoped=true&"
import script from "./GCheckButtonIcon.vue?vue&type=script&lang=ts&"
export * from "./GCheckButtonIcon.vue?vue&type=script&lang=ts&"
import style0 from "./GCheckButtonIcon.vue?vue&type=style&index=0&id=5acba5cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acba5cf",
  null
  
)

export default component.exports